<template>
  <div class="dealers-form default-form">
    <ValidationObserver ref="form">
      <div class="columns">
        <div class="column">
          <div class="row">
            <validation-provider name="Название" rules="required">
              <template #default="{ errors }">
                <label>Название</label>
                <input
                  type="text"
                  :disabled="readOnly"
                  :class="{ 'form-error': errors[0]}"
                  v-model="model.title"
                  placeholder="Название"
                />
                <div v-if="errors[0]" class="error-descr">{{ errors[0] }}</div>
              </template>
            </validation-provider>
          </div>

          <div class="row">
            <validation-provider name="Статус" rules="required">
              <template #default="{ errors }">
                <label>Статус</label>
                <multiselect
                  v-model="model.status"
                  :options="statuses"
                  :disabled="readOnly"
                  :class="{ 'form-error': errors[0]}"
                  track-by="id"
                  label="title"
                  placeholder="Статус"
                />
                <div v-if="errors[0]" class="error-descr">{{ errors[0] }}</div>
              </template>
            </validation-provider>
          </div>

          <div class="row">
            <validation-provider name="Город" rules="required">
              <template #default="{ errors }">
                <label>Город</label>
                <multiselect
                  v-model="model.city"
                  :options="cities"
                  :disabled="readOnly"
                  :class="{ 'form-error': errors[0]}"
                  track-by="id"
                  label="title"
                  placeholder="Город"
                />
                <div v-if="errors[0]" class="error-descr">{{ errors[0] }}</div>
              </template>
            </validation-provider>
          </div>

          <div class="row">
            <validation-provider name="Адрес" rules="required">
              <template #default="{ errors }">
                <label>Адрес</label>
                <multiselect
                  v-model="model.address"
                  :options="model.address"
                  :disabled="readOnly"
                  :class="{ 'form-error': errors[0]}"
                  tag-placeholder="Добавить адрес"
                  placeholder="Найти или добавить адрес"
                  :multiple="true"
                  :taggable="true"
                  @tag="addAddress"
                />
                <div v-if="errors[0]" class="error-descr">{{ errors[0] }}</div>
              </template>
            </validation-provider>
          </div>

          <div class="row">
            <label>Почтовый индекс</label>
            <input
              type="text"
              :disabled="readOnly"
              v-model="model.zip_code"
              placeholder="Почтовый индекс"
            />
          </div>

          <div class="row">
            <validation-provider name="Широта" rules="required">
              <template #default="{ errors }">
                <label>Широта</label>
                <input
                  type="text"
                  :disabled="readOnly"
                  :class="{ 'form-error': errors[0]}"
                  v-model="model.latitude"
                  placeholder="Широта"
                />
                <div v-if="errors[0]" class="error-descr">{{ errors[0] }}</div>
              </template>
            </validation-provider>
          </div>

          <div class="row">
            <validation-provider name="Долгота" rules="required">
              <template #default="{ errors }">
                <label>Долгота</label>
                <input
                  type="text"
                  :disabled="readOnly"
                  :class="{ 'form-error': errors[0]}"
                  v-model="model.longitude"
                  placeholder="Долгота"
                />
                <div v-if="errors[0]" class="error-descr">{{ errors[0] }}</div>
              </template>
            </validation-provider>
          </div>
        </div>

        <div class="column">
          <div class="row">
            <validation-provider name="Адрес электронной почты" rules="required|email">
              <template #default="{ errors }">
                <label>Адрес электронной почты</label>
                <input
                  type="text"
                  :disabled="readOnly"
                  :class="{ 'form-error': errors[0]}"
                  v-model="model.email"
                  placeholder="Адрес электронной почты"
                />
                <div v-if="errors[0]" class="error-descr">{{ errors[0] }}</div>
              </template>
            </validation-provider>
          </div>

          <div class="row">
            <label>Адрес веб-сайта</label>
            <input
              type="text"
              :disabled="readOnly"
              v-model="model.site_url"
              placeholder="Адрес веб-сайта"
            />
          </div>

          <div class="row">
            <validation-provider name="Номера телефонов" rules="required">
              <template #default="{ errors }">
                <label>Номера телефонов</label>
                <multiselect
                  v-model="model.phones"
                  :options="model.phones"
                  :disabled="readOnly"
                  :class="{ 'form-error': errors[0]}"
                  tag-placeholder="Добавить телефон"
                  placeholder="Найти или добавить телефон"
                  :multiple="true"
                  :taggable="true"
                  @tag="addPhone"
                />
                <div v-if="errors[0]" class="error-descr">{{ errors[0] }}</div>
              </template>
            </validation-provider>
          </div>

          <div class="row">
            <label>Адреса электронной почты тест-драйва</label>
            <multiselect
              v-model="model.email_test_drive"
              :options="model.email_test_drive"
              :disabled="readOnly"
              :class="{ 'form-error': errors[0]}"
              tag-placeholder="Добавить адрес"
              placeholder="Адреса электронной почты тест-драйва"
              :multiple="true"
              :taggable="true"
              @tag="addTestDriveEmail"
            />
          </div>

          <div class="row">
            <label>Адреса электронной почты сервисного контракта</label>
            <multiselect
              v-model="model.email_service_contract"
              :options="model.email_service_contract"
              :disabled="readOnly"
              :class="{ 'form-error': errors[0]}"
              tag-placeholder="Добавить адрес"
              placeholder="Адреса электронной почты сервисного контракта"
              :multiple="true"
              :taggable="true"
              @tag="addServiceContractEmail"
            />
          </div>

          <div class="row">
            <label>Адреса электронной почты ТО</label>
            <multiselect
              v-model="model.email_maintenance"
              :options="model.email_maintenance"
              :disabled="readOnly"
              :class="{ 'form-error': errors[0]}"
              tag-placeholder="Добавить адрес"
              placeholder="Адреса электронной почты ТО"
              :multiple="true"
              :taggable="true"
              @tag="addMaintenanceEmail"
            />
          </div>

          <div class="row">
            <label>Адреса электронной почты кузовных работ</label>
            <multiselect
              v-model="model.email_carcase_repair"
              :options="model.email_carcase_repair"
              :disabled="readOnly"
              :class="{ 'form-error': errors[0]}"
              tag-placeholder="Добавить адрес"
              placeholder="Адреса электронной почты кузовных работ"
              :multiple="true"
              :taggable="true"
              @tag="addCarcaseRepairEmail"
            />
          </div>
        </div>
      </div>

      <div class="row">
        <label>Комментарий</label>
        <textarea v-model="model.comment" :disabled="readOnly" rows="10" placeholder="Комментарий" />
      </div>

      <div class="row row--line">
        <checkbox v-model="model.ignore_sync" :disabled="readOnly" />
        <label>Не обновлять при синхронизации</label>
      </div>

      <div class="row row--line">
        <checkbox v-model="model.electric_cars_support" :disabled="readOnly" />
        <label>Работает с электромобилями (e-tron)</label>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { ValidationProvider, ValidationObserver } from 'vee-validate';
import Checkbox from '@/components/common/Checkbox';

export default {
  name: 'dealers-form',

  props: {
    model: Object,
  },

  components: {
    ValidationProvider,
    ValidationObserver,
    Checkbox,
  },

  methods: {
    async validate() {
      return await this.$refs.form.validate();
    },

    addAddress(address) {
      this.$emit('addAddress', address);
    },

    addPhone(phone) {
      this.$emit('addPhone', phone);
    },

    addTestDriveEmail(email) {
      this.$emit('addTestDriveEmail', email);
    },

    addServiceContractEmail(email) {
      this.$emit('addServiceContractEmail', email);
    },

    addMaintenanceEmail(email) {
      this.$emit('addMaintenanceEmail', email);
    },

    addCarcaseRepairEmail(email) {
      this.$emit('addCarcaseRepairEmail', email);
    },
  },

  computed: {
    ...mapGetters({
      statuses: 'dealers/statuses',
      cities: 'dealers/cities',
    }),

    readOnly() {
      return !!this.model.deleted_at;
    },
  },
};
</script>

<style lang="scss" scoped>
.dealers-form {
  .row--line {
    flex-direction: row;
    align-items: center;

    > * {
      margin-right: 8px;
    }
  }
}
</style>
